(() => {
  let attempts = 0;
  function initializeRating() {
    const target = document.querySelector('.ruk_rating_snippet');
    if (!target || target.querySelector('i') || target.dataset.abartInitialized) return;
    if (typeof ratingSnippet === 'function') {
      target.dataset.abartInitialized = 'true';
      ratingSnippet('ruk_rating_snippet', {
        store: 'abart.com',
        color: '#111111',
        textClr: '#5F6062',
        text: 'Reviews',
        lang: document.documentElement.lang || 'en',
        mode: 'default',
        showEmptyStars: false,
        anchorToReviewsWidget: true
      });
      return;
    }
    if (++attempts < 20) window.setTimeout(initializeRating, 500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRating, { once: true });
  } else {
    initializeRating();
  }
})();
